import DatePickerWrapper from "../../../shared/formUtilities/useDatePicker";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import ButtonWrapper from "../../../shared/formUtilities/useButton";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { Box } from "@mui/material";

export const MarketingFilter = ({ formik, onClear }) => {
    return (
        <Box className="bg-white p-5 mb-5 w-full">

            {/* Filter Fields Row */}
            <Box className="flex flex-wrap gap-5">
                <Box className="w-[200px]">
                    <DatePickerWrapper
                        name="fromDate"
                        label="Start Date"
                        defaultMaxDate={true}
                        selected={formik.values.fromDate}
                        onChange={(val) => formik.setFieldValue("fromDate", val)}
                    />
                </Box>

                <Box className="w-[200px]">
                    <DatePickerWrapper
                        name="toDate"
                        label="End Date"
                        defaultMaxDate={true}
                        selected={formik.values.toDate}
                        onChange={(val) => formik.setFieldValue("toDate", val)}
                        minDate={formik.values.fromDate}
                    />
                </Box>
            </Box>

            {/* Buttons Row */}
            <Box className="flex justify-end mt-5 gap-4 flex-col md:flex-row">

                <ButtonWrapper
                    classList="md:!w-[140px] !w-full"
                    label="Search"
                    type="submit"
                    icon={<ManageSearchIcon />}
                />

                <ButtonWrapper
                    variant="outlined"
                    onClick={() => onClear(formik)}
                    classList="md:!w-[140px] !w-full !text-primary"
                    label="Reset"
                    loaderSpinnerClass="!text-primary"
                    icon={<ClearAllIcon />}
                />
            </Box>
        </Box>
    );
};
